import { t } from "@lingui/core/macro";
import { ComponentProps } from "react";

import { Input } from "@whoosh/design-system/src/components/controls/Input";
import {
  CloseIcon,
  SearchIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import { Pressable } from "@whoosh/design-system/src/components/primitive";
import { Box } from "@whoosh/design-system/src/components/primitive";

type AddPeopleSearchBoxProps = {
  setSearch: (val: string) => void;
  search: string;
  px?: ComponentProps<typeof Box>["px"];
};

export const AddPeopleSearchbox = ({
  setSearch,
  search,
  px = 6,
}: AddPeopleSearchBoxProps) => {
  return (
    <Box px={px} minWidth="100%" testID="add-people-search-input-box">
      <Input<"text">
        value={search}
        placeholder={t`Search People`}
        onChange={setSearch}
        leftIcon={<SearchIcon />}
        rightIcon={
          search.length > 0 ? (
            <Pressable onPress={() => setSearch("")}>
              <CloseIcon />
            </Pressable>
          ) : undefined
        }
        name={"add-players-search-input"}
        testID="add-people-search-input"
      />
    </Box>
  );
};
